// Date presets for custom field filters. A preset is stored by name and resolved again on every load, so
// a saved "this week" always means the current week. Ranges are inclusive calendar dates in the viewer's
// local time; the week starts on the viewer's locale week start, like every other date preset in Forecast.
import type {Moment} from 'moment';

export const DATE_PRESETS = ['today', 'this_week', 'this_month', 'last_30_days', 'next_30_days'] as const;
export type DatePreset = (typeof DATE_PRESETS)[number];

export const isDatePreset = (value: unknown): value is DatePreset => (DATE_PRESETS as readonly unknown[]).includes(value);

export interface IsoDateRange {
	from: string;
	to: string;
}

const ISO = 'YYYY-MM-DD';

export function resolveDatePreset(preset: DatePreset, today: Moment): IsoDateRange {
	const day = today.clone().startOf('day');
	switch (preset) {
		case 'this_week':
			return {from: day.clone().startOf('week').format(ISO), to: day.clone().endOf('week').format(ISO)};
		case 'this_month':
			return {from: day.clone().startOf('month').format(ISO), to: day.clone().endOf('month').format(ISO)};
		case 'last_30_days':
			return {from: day.clone().subtract(29, 'days').format(ISO), to: day.format(ISO)};
		case 'next_30_days':
			return {from: day.format(ISO), to: day.clone().add(29, 'days').format(ISO)};
		case 'today':
		default:
			return {from: day.format(ISO), to: day.format(ISO)};
	}
}
